import FellasIcon from './Fellas.png'

const icons = {
  FELLAS_ICON: FellasIcon
}

export default icons